<template>
  <generic-modal
    :title="$t('bulk categorize')"
    :buttons="buttons"
    ref="generic_modal"
  >
    <div class="field">
      <generic-dropdown
        :title="$t('categories')"
        :placeholder="$t('select')"
        :is_multiple="true"
        url="/product/category/catalog"
        name_field="name"
        value_field="category_id"
        @change="set_category"
        ref="category_dropdown"
      />
    </div>
    <div class="field">
      <generic-dropdown
        :title="$t('products')"
        :placeholder="$t('select')"
        :is_multiple="true"
        url="/product/catalog"
        name_field="name"
        value_field="product_id"
        @change="set_product"
        ref="product_dropdown"
      />
    </div>
    <div class="notification is-danger mt-5" v-if="error">
      <p v-html="error"></p>
    </div>
  </generic-modal>
</template>
<script>
import {
  put,
  error_message,
  get,
  post,
  error_alert,
  api_host,
  generate_error_message_text,
  get_currency_settings,
  change_active_tab,
} from "@/utils";
import GenericModal from "@/components/generic_modal/Index.vue";
import GenericUploader from "@/components/generic_uploader/Index.vue";
import GenericDropdown from "@/components/generic_dropdown/Index.vue";
import VLazyImage from "v-lazy-image";

export default {
  name: "BulkCategorizeModal",
  components: { GenericModal, GenericUploader, VLazyImage, GenericDropdown },
  data() {
    return {
      api_host,
      buttons: [
        {
          text: this.$t("save"),
          class: "is-primary is-rounded",
          icon: "fa fa-save",
          click: this.save,
          disabled: "this.is_form_invalid",
        },
        {
          text: this.$t("cancel"),
          class: "is-rounded",
          icon: "fa fa-close",
          click: this.close_modal,
        },
      ],
      meta: {},
      error: "",
      // uuid: "",
    };
  },
  computed: {
    is_form_invalid() {
      let v = this;
      // return false;
      return (
        !v.meta.products ||
        !v.meta.products.length ||
        !v.meta.categories ||
        !v.meta.categories.length
      );
    },
  },
  methods: {
    close_modal() {
      let v = this;
      v.$refs.generic_modal.close_modal();
      v.set_initial_state();
    },
    show_modal() {
      let v = this;
      v.set_initial_state();
      v.$refs.generic_modal.show_modal();
    },
    save() {
      let v = this;
      put("/product/category/bulk", v.meta)
        .then(() => {
          v.$emit("success");
          v.$refs.generic_modal.close_modal();
        })
        .catch((error) => {
          v.error = generate_error_message_text(error);
        });
    },
    set_initial_state() {
      let v = this;
      v.meta = {
        products: [],
        categories: [],
      };
      v.error = "";
      v.$refs.category_dropdown.clear();
      v.$refs.product_dropdown.clear();
      // v.uuid = "";
    },
    set_category(categories) {
      let v = this;
      v.meta.categories = categories;
    },
    set_product(products) {
      let v = this;
      v.meta.products = products;
    },
  },
  mounted() {},
  watch: {
    is_form_invalid() {
      let v = this;
      v.buttons[0].disabled = v.is_form_invalid;
    },
  },
};
</script>
<style></style>
